export const Site = process.env.VUE_APP_SITE_URL
export const Host = process.env.VUE_APP_BASE_API
// 缓存前缀
export const CachePostfix = 'jiu97_'
export const AppKey = process.env.VUE_APP_KEY
export const AppSecret = process.env.VUE_APP_SECRET
export const Layout = 'default'
export const DashboardUrl = '/agency/index/index'
export const AppName = process.env.VUE_APP_TITLE
export const AppColor = process.env.VUE_APP_TITLE
export const AppVersions = process.env.VUE_APP_VERSIONS

export default {
    Site,
    Host,
    CachePostfix,
    AppKey,
    AppSecret,

    Layout,
    DashboardUrl,
    AppName,
    AppVersions
}
